import React from "react";
import {
	SiFacebook,
	SiInstagram,
	SiLinkedin,
	SiGithub,
	SiTwitter,
} from "react-icons/si";
import { FaCopyright } from "react-icons/fa";

export const Footer = () => {
	return (
		<footer className="select-none flex flex-col justify-center items-center w-screen bg-gray-900 relative overflow-hidden">
			<h2 className="text-center text-yellow-300 font-Montserrat font-bold ">
				Sigueme en mis redes sociales
			</h2>
			<br />
			<div className="flex justify-center items-center">
				<a
					href="https://www.facebook.com/profile.php?id=100009365110374"
					target="_blank"
					rel="noreferrer"
				>
					<SiFacebook className="mx-4  text-2xl hover:text-yellow-300 transition-all duration-200 ease-linear cursor-pointer" />
				</a>
				<a
					href="https://www.instagram.com/gkevinyamil/"
					target="_blank"
					rel="noreferrer"
				>
					<SiInstagram className="mx-4  text-2xl hover:text-yellow-300 transition-all duration-200 ease-linear cursor-pointer" />
				</a>

				<a
					href="https://www.linkedin.com/in/kevin-garc%C3%ADa-0849a21a8/"
					target="_blank"
					rel="noreferrer"
				>
					<SiLinkedin className="mx-4  text-2xl hover:text-yellow-300 transition-all duration-200 ease-linear cursor-pointer" />
				</a>
				<a
					href="https://github.com/kevinShogun"
					target="_blank"
					rel="noreferrer"
				>
					<SiGithub className="mx-4  text-2xl hover:text-yellow-300 transition-all duration-200 ease-linear cursor-pointer" />
				</a>
				<a
					href="https://twitter.com/gkevin_y"
					target="_blank"
					rel="noreferrer"
				>
					<SiTwitter className="mx-4  text-2xl hover:text-yellow-300 transition-all duration-200 ease-linear cursor-pointer" />
				</a>
			</div>
			<br />

			<h2 className="text-center text-yellow-300 font-Montserrat font-bold text-2xl flex justify-center items-center">
				Kevin García <FaCopyright className="mx-3" />| 2021 All rights reserved.
			</h2>
		</footer>
	);
};
